import { GalleryCollector } from "kreate-common/modules/business-types";
import {
  DisplayableError,
  useDisplayableError,
} from "kreate-common/modules/displayable-error";
import {
  getResourceKey$GetGalleryCollector,
  httpGet$GetGalleryCollector,
} from "kreate-server/commands/GetGalleryCollector/fetcher";
import useSWR from "swr";

type AddressIsh = string; // address or handle

export function useGalleryCollector$GivenAddressIsh(
  addressIsh: AddressIsh
): [GalleryCollector | undefined, DisplayableError | undefined] {
  const swr = useSWR(
    getResourceKey$GetGalleryCollector({ addressOrHandle: addressIsh }),
    async () =>
      await httpGet$GetGalleryCollector("/api/v1/collector-gallery/collector", {
        addressOrHandle: addressIsh,
      })
  );

  const galleryCollector = swr.data;
  const displayableError = useDisplayableError(
    swr.error,
    "Failed to fetch gallery collector"
  );
  return [galleryCollector, displayableError];
}
